import angular from 'angular';

import Component from './associate-entity-modal.component';

const AssociateEntityModal = angular
    .module('control-room.commons.content.component.associate-entity-modal', [])
    .component('crAssociateEntityModal', Component);

export default AssociateEntityModal;
